import { api } from './client';
import type { RecurrencePattern, RecurringTask, TaskPriority } from '../types';

interface CreateRecurringTaskInput {
  title: string;
  description?: string;
  project_id: string;
  assignee_id: string;
  priority?: TaskPriority;
  recurrence_pattern: RecurrencePattern;
  recurrence_day?: number;
}

interface UpdateRecurringTaskInput {
  title?: string;
  description?: string;
  assignee_id?: string;
  priority?: TaskPriority;
  recurrence_pattern?: RecurrencePattern;
  recurrence_day?: number | null;
  is_active?: boolean;
}

export const recurringTasksApi = {
  getAll: (projectId?: string) =>
    api.get<{ recurringTasks: RecurringTask[] }>(
      '/recurring-tasks',
      projectId ? { project_id: projectId } : undefined,
    ),

  create: (data: CreateRecurringTaskInput) =>
    api.post<{ recurringTask: RecurringTask }>('/recurring-tasks', data),

  update: (id: string, data: UpdateRecurringTaskInput) =>
    api.patch<{ recurringTask: RecurringTask }>(`/recurring-tasks/${id}`, data),

  delete: (id: string) => api.delete<{ message: string }>(`/recurring-tasks/${id}`),
};
